<template>
  <div class="shipping-form__shipping">
    <div class="">
      <div class="row">
        <div hidden class="col customer-type">
          <p class="label">Shipment Method</p>
          <div class="d-flex mt-3 mb-4">
            <label class="radio-label" for="terminal-to-terminal">
              <input
                type="radio"
                id="terminal-to-terminal"
                value="terminal-to-terminal"
                v-model="shippingInformation.shippingMethod"
              />
              Terminal-to-Terminal
              <span></span>
            </label>

            <label class="radio-label ml-4" for="door-door">
              <input
                type="radio"
                id="door-door"
                value="door-door"
                v-model="shippingInformation.shippingMethod"
              />
              Door-to-Door
              <span></span>
            </label>

            <label class="radio-label ml-4" for="terminal-to-door">
              <input
                type="radio"
                id="terminal-to-door"
                value="terminal-to-door"
                v-model="shippingInformation.shippingMethod"
              />
              Terminal-to-Door
              <span></span>
            </label>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <p class="font-bold">Request Details</p>
        <p><span class="font-semibold">Service Type:</span> {{ shippingMethod }}</p>
        <div class="flex gap-4">
          <p>From: {{ shipperAdd.name }}</p>
          <p class="h-4 mt-1 border-r border-black"></p>
          <p>To: {{ consigneeAdd.name }}</p>
        </div>

        <div class="row ml-n5 mt-5">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="input-wrapper">
              <label for="name" class="label">
                <base-checkbox
                  label="Add Return Address / Forwarding Address"
                  id="delivery-code"
                  v-model="addReturn"
                />

                <tool-tip
                  text="If package cannot be delivered, where should it be returned to?"
                />
              </label>
              <vue-google-autocomplete
                id="map2"
                ref="shipperAddress"
                classname="input"
                placeholder="Enter address"
                v-if="addReturn"
                v-on:placechanged="getAddress"
              >
              </vue-google-autocomplete>
            </div>
          </div>
        </div>

        <div>
          <p class="font-medium">Select Shipping Service</p>

          <!-- <div class="border border-gray-100 mt-3 rounded-lg h-16 flex gap-4"> -->
            <!-- <div :style="{ width: '250px' }" class="pt-2">
              <form-select
                placeholder="Sort by Carrier"
                color="#7A90A7"
                bgColor="white"
                border="0px"
                height="50px"
                class="border-0 w-full h-20"
              >
                <b-form-checkbox
                  v-for="carrier in carriersSort"
                  :key="carrier"
                  :name="carrier"
                  :value="carrier"
                  v-model="filter.carrier"
                  :label="carrier"
                >
                  {{ carrier }}
                </b-form-checkbox>
              </form-select>
            </div>
            <div
              :style="{ marginTop: '20px', border: '1px dashed #4142455C' }"
              class="h-6"
            ></div> -->

            <!-- <div :style="{ width: '250px' }" class="pt-2">
              <form-select
                placeholder="Sort by Categories"
                color="#7A90A7"
                bgColor="white"
                border="0px"
                height="50px"
                class="border-0 w-full h-20"
              >
                <b-form-checkbox
                  v-for="category in categorySort"
                  :key="category"
                  :name="category"
                  :value="category"
                  v-model="filter.category"
                  :label="category"
                >
                  {{ category }}
                </b-form-checkbox>
              </form-select>
            </div> -->

            <!-- <div
              :style="{ marginTop: '20px', border: '1px dashed #4142455C' }"
              class="h-6"
            ></div> -->

            <!-- <div :style="{ width: '250px' }" class="pt-2">
              <form-select
                placeholder="Sort by Cost"
                color="#7A90A7"
                bgColor="white"
                border="0px"
                height="50px"
                class="border-0 w-full h-20"
              >
                <b-form-checkbox
                  v-for="cost in costSort"
                  :key="cost"
                  :name="cost"
                  :value="cost"
                  v-model="filter.cost"
                  :label="cost"
                >
                  {{ cost }}
                </b-form-checkbox>
              </form-select>
            </div> -->

            <!-- <div
              :style="{ marginTop: '20px', border: '1px dashed #4142455C' }"
              class="h-6"
            ></div> -->

            <!-- <div :style="{ width: '250px' }" class="pt-2">
              <form-select
                color="#7A90A7"
                placeholder="Sort by Timeline"
                bgColor="white"
                border="0px"
                height="50px"
                class="border-0 w-full h-20"
              >
                <b-form-checkbox
                  v-for="timeline in timelineSort"
                  :key="timeline"
                  :name="timeline"
                  :value="timeline"
                  v-model="filter.timeline"
                  :label="timeline"
                >
                  {{ timeline }}
                </b-form-checkbox>
              </form-select>
            </div> -->
          <!-- </div> -->

          <div class="flex gap-2">
            <div @click="scrollShippingService('left')">
              <ArrowLeftIcon :style="{ marginTop: '120px' }" class="cursor-pointer" />
            </div>
            <div
              v-if="
                (shippingMethod == 'terminal-to-door') ||
                shippingMethod == 'terminal-to-terminal' ||
                (shippingMethod == 'door-to-door' && shippingRouteType == 'inter-state')
              "
              ref="shippingservice"
              id="shippingservice"
              class="shipping-services"
            >
              <loader class="mx-auto" v-if="gettingShippingServices" />
              <p
                class="text-red-500 text-2xl"
                v-if="!gettingShippingServices && shippingServices.length == 0"
              >
                No Shipping Service for selected route, please try another route.
              </p>
              <div
                class="align-items-stretch"
                v-for="(shippingService, index) in filteredShippingService"
                :key="shippingService.id"
              >
                <div
                  class="shipping-service cursor-pointer"
                  :class="{
                    selected: selectedShippingIndex == index,
                  }"
                  @click="
                    (shippingInformation.shippingServiceId = shippingService.id),
                      (selectedShippingIndex = index);
                    savePaymentInformation(shippingService);
                    getCostEngine();
                  "
                >
                  <div class="flex gap-2 justify-center">
                    <img
                      src="@/assets/images/auth/auth-bg.png"
                      class="rounded-full w-5 h-5 mt-1"
                    />
                    <p class="text-left mt-1">{{ shippingService.orgName }}</p>
                  </div>

                  <div class="px-8 mt-1">
                    <p class="" :style="{ border: '1px solid #DAE8F6' }"></p>
                  </div>
                  <p class="mt-1 text-sm" :style="{ color: '#383F51' }">
                    {{ shippingService.costData.costTye }}
                  </p>
                  <p class="text-3xl font-medium">
                    &#8358;{{ shippingService.costData.totalCost }}
                  </p>
                  <p color="#09B78A" :style="{ color: '#09B78A', fontSize: '10px' }">
                    Two-Way Total
                  </p>
                  <p>
                    {{
                      shippingService.costData
                        ? shippingService.costData.literature
                        : "N/A"
                    }}
                  </p>
                  <div class="px-8 mt-1">
                    <p class="" :style="{ border: '1px solid #DAE8F6' }"></p>
                  </div>

                  <p :style="{ color: '#383F51' }" class="service-schedule">
                    Next Day {{ shippingService.shippingMethod }} Service
                  </p>
                </div>
              </div>
            </div>
            <!-- (shippingMethod == 'terminal-to-door' &&
            shippingRouteType == 'intra-state') ||
          (shippingMethod == 'door-to-door' && shippingRouteType == 'intra-state') -->
            <div
              v-if="(shippingMethod == 'door-to-door' && shippingRouteType == 'intra-state')"
              ref="shippingservice"
              id="shippingservice"
              class="shipping-services"
            >
              <loader class="mx-auto" v-if="gettingTripsVehicles" />
              <p
                class="text-red-500 text-2xl"
                v-if="!gettingTripsVehicles && tripsVehicles.length == 0"
              >
                No Trips Vehicles for selected route, please try another route.
              </p>
              <div
                class="align-items-stretch"
                v-for="(tripVehicle, index) in filteredTripsVehicles"
                :key="index"
              >
                <div
                  class="shipping-service cursor-pointer"
                  :class="{
                    selected: selectedVehicleIndex == index,
                  }"
                  @click="
                    (shippingInformation.tripVehicleId = index),
                      (selectedVehicleIndex = index);
                    saveVehicleType(tripVehicle, tripVehicle.vehicleType);
                  "
                >
                  <div class="flex gap-2 justify-center">
                    <img
                      src="@/assets/images/auth/auth-bg.png"
                      class="rounded-full w-5 h-5 mt-1"
                    />
                    <p class="text-left mt-1">{{ tripVehicle.vehicleType }}</p>
                  </div>

                  <div class="px-8 mt-1">
                    <p class="" :style="{ border: '1px solid #DAE8F6' }"></p>
                  </div>
                  <p class="mt-1 text-sm" :style="{ color: '#383F51' }">
                    {{ tripVehicle.class }}
                  </p>
                  <p class="text-3xl font-medium">&#8358;{{ Math.round(tripVehicle.cost) }}</p>
                  <p color="#09B78A" :style="{ color: '#09B78A', fontSize: '10px' }">
                    Two-Way Total
                  </p>
                  <div class="flex justify-center gap-2" :style="{ minHeight : '50px' }">
                    <div v-if="tripVehicle.isCheapest" class="px-3 pt-1 text-center rounded-3xl h-8 my-2" :style="{ 'color': 'black', 'background-color' : '#FCC210' }">
                      Cheapest
                    </div>
                    <div v-if="tripVehicle.isFastest" class="px-3 pt-1 text-center rounded-3xl h-8 my-2" :style="{ 'color': 'white', 'background-color' : '#09B78A' }">
                      Fastest
                    </div>
                  </div>
                  <div class="px-8 mt-1">
                    <p class="" :style="{ border: '1px solid #DAE8F6' }"></p>
                  </div>

                  <p :style="{ color: '#383F51' }" class="service-schedule">
                    Next Day {{ tripVehicle.shippingMethod }} Service
                  </p>
                </div>
              </div>
            </div>

            <div @click="scrollShippingService('right')">
              <ArrowRightIcon :style="{ marginTop: '120px' }" class="cursor-pointer" />
            </div>
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <p class="cursor-pointer underline" @click="$emit('back-one-form')">Back</p>
        <span class="mr-6">
          <primary-button
            button-text="Continue"
            :loading="isLoading"
            :disabled="disableSubmit"
            @click="createShippingId"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
// import CostTypes from "../CostTypes";
// import DirectionsRenderer from "./Modals/DirectionsRenderer";
import ArrowLeftIcon from "@/components/UI/svgs/ArrowLeftIcon.vue";
import ArrowRightIcon from "@/components/UI/svgs/ArrowRightIcon.vue";

export default {
  name: "shipping-details-form",
  components: {
    VueGoogleAutocomplete,
    // CostTypes,
    // DirectionsRenderer,
    ArrowLeftIcon,
    ArrowRightIcon,
  },
  data() {
    return {
      addReturn: false,
      shippingServiceTerminal: [
        {
          id: 1,
          orgName: "GIG Logistics",
          type: "Express",
          cost: "15000",
          shippingMethod: "Land",
        },
        {
          id: 2,
          orgName: "GIG Logistics",
          type: "Standard",
          cost: "15000",
          shippingMethod: "Land",
        },
        {
          id: 3,
          orgName: "GIG Logistics",
          type: "Economy",
          cost: "15000",
          shippingMethod: "Land",
        },
        {
          id: 4,
          orgName: "ABC Logistics",
          type: "Economy",
          cost: "15000",
          shippingMethod: "Land",
        },
        {
          id: 5,
          orgName: "ABC Logistics",
          type: "Express",
          cost: "15000",
          shippingMethod: "Land",
        },
      ],
      timelineSort: ["All", "24hrs Delevery", "48hrs Delivery", "One Week"],
      carriersSort: ["All", "ABC", "GIG", "YSG", "Chisco"],
      costSort: ["All", "1,000 - 2,000", "2,000 - 3,000", "4,000 - 5,000"],
      categorySort: ["All", "Economy", "Standard", "Express"],
      filter: {
        carrier: ["All"],
        cost: ["All"],
        category: ["All"],
        timeline: ["All"],
      },
      shippingInformation: {
        shipperLocationId: null,
        consigneeLocationId: null,
        tripMode: "single-trip",
        shippingServiceId: null,
        vehicleType: null,
        sourcePickupTime: null,
        destinationPickupTime: null,
        portOrigin: null,
        portDestination: null,
        payOnDelivery: false,
        deliveryConfirmation: false,
        paymentStatus: "not-paid",
        stops: [],
        returnOrForwardingAddress: null,
        currentStep: 4,
      },
      payload: {
        shipperLocationId: "",
        consigneeLocationId: "",
        shippingMethod: "",
        shippingServiceId: "",
        tripMode: "single-trip",
        sourcePickupTime: "",
        paymentStatus: "not paid",
        destinationPickupTime: "",
        portOrigin: "",
        portDestination: "",
        stops: "",
        payOndelivery: "",
        specifiedAmount: "",
        returnOrForwardingAddress: "",
        deliveryConfirmation: "",
      },
      transactionId: "",
      singleStop: "",
      selectedPickupDay: "",
      selectedDropoffDay: "",
      stopsInputs: [],
      preferredPickupTime1: "",
      preferredPickupTime2: "",
      preferredDropoffTime1: "",
      preferredDropoffTime2: "",
      selectedShippingService: "",
      invalidCollectionTime: false,
      takeOffArray: [],
      validProps: true,
      pickUpArray: [],
      invalidDeliveryTime: false,
      paymentOnDeliveryOptions: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      isLoading: false,
      shippingServices: [],
      paymentInformation: {
        packageeId: "",
        serviceCost: "",
        serviceType: "",
      },
      costs: {},
      costSelected: "",
      address: {
        lat: "",
        lng: "",
        name: "Douglas Road",
      },
      origin: {},
      currentPlace: null,
      markers: [],
      places: [],
      path: [],
      center: { lat: 43.3, lng: 10.3 },
      gettingShippingServices: false,
      selectedShippingIndex: null,
      filteredShippingService: [],
      selectedVehicleIndex: null,
      gettingTripsVehicles: false,
      tripsVehicles: [],
      filteredTripsVehicles: [],
    };
  },
  watch: {
    "shippingInformation.shippingServiceId"() {
      this.getShippingServiceDetails();
    },
    "$store.getters.shipperInformation.address.name"() {
      this.getTerminals();
    },
    "$store.getters.consigneeInformation.address.name"() {
      this.getTerminals();
    },
    pickUp() {
      if (!this.checkCollectionTime()) {
        this.invalidCollectionTime = true;
        this.validProps = false;
        return;
      }
      this.invalidCollectionTime = false;
      this.validProps = true;
    },
    delivery() {
      if (!this.checkDeliveryTime()) {
        this.invalidDeliveryTime = true;
        this.validProps = false;
        return;
      }
      this.invalidDeliveryTime = false;
      this.validProps = true;
    },
    "shippingInformation.dropOff"(dropOff) {
      if (this.shippingInformation.pickUp) {
        this.getShippingServicesByTerminal(dropOff, this.shippingInformation.pickUp);
      }
    },
    "shippingInformation.pickUp"(pickUp) {
      if (this.shippingInformation.dropOff) {
        this.getShippingServicesByTerminal(this.shippingInformation.dropOff, pickUp);
      }
    },
    filter() {
      let filteredShippingService = this.shippingService.filter((item) => {
        return (
          item.costData.costTye.includes(this.filter.category) &&
          item.orgName.includes(this.filter.carrier) &&
          item.costData.literature.includes(this.filter.timeline)
        );
      });
      if (Array.isArray(this.filterPayload.cost)) {
        this.filteredShippingService = filteredShippingService.filter(
          (item) =>
            item.costData.totalCost >= this.filterPayload.cost[0] &&
            item.costData.totalCost <= this.filterPayload.cost[1]
        );
      } else {
        this.filteredShippingService = filteredShippingService;
      }
    },
  },
  activated() {
    this.shippingService = [];
    this.cost = [];
    this.getShippingServices();
  },
  computed: {
    filterPayload() {
      let cost =
        this.filter.cost != "All"
          ? this.filter.cost.replace(/,/g, "").split(" - ").map(Number)
          : "All";
      return {
        category: this.filter.category == "All" ? "" : this.filter.category,
        cost: cost == "All" ? "" : [cost[0], cost[1]],
        carrier: this.filter.carrier == "All" ? "" : this.filter.carrier,
        timeline: this.filter.timeline == "All" ? "" : this.filter.timeline,
      };
    },
    pickUp() {
      // A dummy data just to keep track of pick-up
      return [this.preferredPickupTime2, this.preferredPickupTime1];
    },
    delivery() {
      // A dummy data just to keep track of deleivery-up
      return [this.preferredDropoffTime1, this.preferredDropoffTime2];
    },
    isNewConsignee() {
      return this.$store.getters.isNewConsignee;
    },
    packageType() {
      return this.$store.getters.packageType;
    },
    disableSubmit() {
      if(this.shippingMethod == "terminal-to-terminal" && !this.shippingInformation.shippingServiceId && !this.selectedShippingIndex) return true;
     return  ((this.shippingMethod == "door-to-door" ||
        this.shippingMethod == "terminal-to-door") &&
        this.shippingRouteType == "intra-state" &&
        this.shippingInformation.vehicleType == null)
      // return this.shippingInformation.shippingServiceId == null ? true : false;
    },
    shipperAdd() {
      return this.$store.getters.shipperInformation.address;
    },
    consigneeAdd() {
      return this.$store.getters.consigneeInformation.address;
    },
    destination() {
      return {
        lat: this.consigneeAdd.lat ? this.consigneeAdd.lat : 0,
        lng: this.consigneeAdd.lng ? this.consigneeAdd.lng : 0,
      };
    },
    shippingMethod() {
      console.log(">>>>",this.$store.state)
      return `${this.$store.state.bookingModule.thirdPLShippingMethosStart}-to-${this.$store.state.bookingModule.thirdPLShippingMethosEnd}`;
    },
    shippingRouteType() {
      return this.$store.state.bookingModule.newBooking.routeType;
    },
  },
  mounted() {
    this.getShippingServices();
    this.getTripsVehicle();
    // this.getTerminals();
    this.getDoorToDoorShippingServices();

    // this.geolocate();

    let consignee = this.$store.getters.consigneeInformation;
    this.address = consignee.address;

    // this.$refs?.deliveryAddress?.update(this.formatAddress(consignee?.address));
  },
  methods: {
    setPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function () {
      this.origin = {
        lat: this.shipperAdd.lat ? this.shipperAdd.lat : 0,
        lng: this.shipperAdd.lng ? this.shipperAdd.lng : 0,
      };

      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    compareTime(start, end) {
      return this.sumUpArray(end.split(":")) > this.sumUpArray(start.split(":"));
    },
    sumUpArray(val) {
      let total = 0;
      total = total + Number(val[0]) * 3600;
      total = total + Number(val[1]) * 60;
      total = total + Number(val[2]);

      return total;
    },
    checkCollectionTime() {
      return this.compareTime(this.preferredPickupTime1, this.preferredPickupTime2);
    },
    checkDeliveryTime() {
      return this.compareTime(this.preferredDropoffTime1, this.preferredDropoffTime2);
    },
    async getDoorToDoorShippingServices() {
      await this.$_serviceTerminals();
    },
    async getTerminals() {
      let shipperAdd = this.$store.getters.shipperInformation.address;
      let consigneeAdd = this.$store.getters.consigneeInformation.address;
      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: consigneeAdd.lat,
          lng: consigneeAdd.lng,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);

        this.takeOffArray = response.data.data.takeOffLocation;
        this.pickUpArray = response.data.data.arrivalLocation;

        this.$store.dispatch("saveTakeOffTerminals", this.takeOffArray);
        this.$store.dispatch("savePickUpTerminals", this.pickUpArray);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getServiceTerminals() {
      try {
        await this.$_serviceTerminals();
      } catch (error) {
        this.handleError(error);
      }
    },
    async miniUpdateShipping() {
      let consigneeAdd = this.$store.getters.consigneeInformation.address;
      let dropOff = this.takeOffArray.find(
        (x) => x.id == this.shippingInformation.dropOff
      );

      (this.origin = {
        lat: Number(dropOff.lat),
        lng: Number(dropOff.long),
      }),
        (this.center = {
          lat: consigneeAdd.lat ? consigneeAdd.lat : 10.34,
          lng: consigneeAdd.lng ? consigneeAdd.lng : 7.23,
        });

      this.shippingInformation.shipperLocationId = this.$store.getters.takeOffLocationId;
      this.shippingInformation.consigneeLocationId = this.$store.getters.deliveryLocationId;
      this.shippingInformation.sourcePickupTime =
        this.selectedPickupDay + " " + this.preferredPickupTime1;
      this.shippingInformation.destinationPickupTime =
        this.selectedDropoffDay + " " + this.preferredDropoffTime1;

      this.shippingInformation.id = this.$store.state.bookingModule.shippingId;
      delete this.shippingInformation.sourcePickupTime;
      delete this.shippingInformation.destinationPickupTime;
      delete this.shippingInformation.pickUp;

      this.shippingInformation.id = this.$store.state.bookingModule.shippingId;
      let payload = {
        payload: this.shippingInformation,
      };
      try {
        await this.$_createShippingId(payload);

        this.getCostEngineByShipping();
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    async createShippingId() {
      if (this.isLoading && this.validProps) return;

      this.isLoading = true;

      this.shippingInformation.shipperLocationId = this.$store.getters.takeOffLocationId;
      this.shippingInformation.consigneeLocationId = this.$store.getters.deliveryLocationId;
      // this.shippingInformation.sourcePickupTime =
      //   this.selectedPickupDay + " " + this.preferredPickupTime1;
      // this.shippingInformation.destinationPickupTime =
      //   this.selectedDropoffDay + " " + this.preferredDropoffTime1;

      this.shippingInformation.id = this.$store.state.bookingModule.shippingId;

      if (
        this.shippingInformation.shippingMethod == "terminal-to-terminal" ||
        this.shippingInformation.shippingMethod == "terminal-to-door"
      ) {
        delete this.shippingInformation.sourcePickupTime;
        delete this.shippingInformation.destinationPickupTime;
      } else if (this.shippingInformation.shippingMethod == "door-door") {
        delete this.shippingInformation.pickUp;
        delete this.shippingInformation.dropOff;
      }

      let payload = {
        payload: this.shippingInformation,
      };
      try {
        let response = await this.$_createShippingId(payload);
        this.$store.dispatch("saveShippingId", response.data.data.shipping.id);

        console.log(response.data.data.shipping);

        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    newshipping() {
      this.payload.shipperLocationId = this.$store.getters.takeOffLocationId;
      this.payload.consigneeLocationId = this.$store.getters.deliveryLocationId;
      this.payload.sourcePickupTime =
        this.selectedPickupDay + ", " + this.preferredPickupTime1;
      this.payload.destinationPickupTime =
        this.selectedDropoffDay + ", " + this.preferredDropoffTime1;
      this.isLoading = true;
    },
    async submitShippingInformation() {
      this.shippingInformation.shipperLocationId = this.$store.getters.takeOffLocationId;
      this.shippingInformation.consigneeLocationId = this.$store.getters.deliveryLocationId;
      this.shippingInformation.sourcePickupTime =
        this.selectedPickupDay + ", " + this.preferredPickupTime1;
      this.shippingInformation.destinationPickupTime =
        this.selectedDropoffDay + ", " + this.preferredDropoffTime1;
      this.isLoading = true;
      try {
        const response = await this.$_submitShippingInformation(
          { payload: this.shippingInformation },
          this.$store.getters.shippingId
        );

        this.isLoading = false;
        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    handleResponse(response) {
      this.$store.dispatch("saveBookingInformation", {
        property: "shippingInformation",
        value: response.data.data.shipping,
      });

      this.$emit("save-response", response.data.data.shipping);
      this.$store.dispatch("saveLastCompletedFormNo", 4);
      this.$emit("change-form");
    },
    submitPaymentInformation() {
      this.isLoading = true;

      let allPackageIds = this.$store.getters.packageIds;
      allPackageIds.forEach((id) => {
        this.paymentInformation.packageeId = id;
        this.processPackagePayment();
      });
      this.submitShippingInformation();
    },
    async processPackagePayment() {
      try {
        const response = await this.$_submitPaymentInformation(this.paymentInformation);
        const paymentInformation = response.data.data.payment;
        this.$store.dispatch("saveSinglePaymentInformation", paymentInformation);
        this.$store.dispatch("savePaymentId", paymentInformation.id);
      } catch (error) {
        this.handleError(error);
      }
    },
    savePaymentInformation(paymentInformation) {
      this.$store.dispatch("savePaymentInformation", paymentInformation);
      this.paymentInformation.serviceCost = paymentInformation.serviceCost;
      this.paymentInformation.serviceType = paymentInformation.shippingMethod;
    },
    saveVehicleType(tripVehicle, vehicleType) {
      this.$store.dispatch("saveBookingInformation", {
        property: "vehicleType",
        value: vehicleType,
      });
      this.$store.dispatch("setTripService", tripVehicle);
      this.shippingInformation.vehicleType = vehicleType;
    },
    async getShippingServices() {
      this.gettingShippingServices = true;
      try {
        let payload = {
          shipperLocationId: this.$store.getters.shipperInformation.id,
          consigneeLocationId: this.$store.getters.consigneeInformation.id,
          shippingId: this.$store.state.bookingModule.newBooking.shippingInformation.id,
          shipmentType: "single",
          terminalType: this.$store.state.bookingModule.newBooking.shippingMethod,
          userType: "3PL",
          orgId: this.$store.state.authentication.organizationId,
        };
        await this.newGetShippingServiceByRoute(payload).then((response) => {
          this.shippingServices = response.data.data.shippingServices.filter(
            (x) => x != null
          );
          this.gettingShippingServices = false;
          this.filteredShippingService = response.data.data.shippingServices.filter(
            (item) => item
          );
          this.carriersSort = Array.from(
            new Set([
              "All",
              ...this.shippingServices.map((item) => {
                return item.orgName;
              }),
            ])
          );
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async getTripsVehicle() {
      this.gettingTripsVehicles = true;

      try {
        let payload = {
          origin: {
            latitude: this.$store.getters.shipperInformation.address.lat,
            longitude: this.$store.getters.shipperInformation.address.lng,
          },
          destination: {
            latitude: this.$store.getters.consigneeInformation.address.lat,
            longitude: this.$store.getters.consigneeInformation.address.lng,
          },
          shippingId: this.$store.state.bookingModule.newBooking.shippingInformation.id,
          type: "single",
        };
        await this.$_getTripsVehicles(payload).then((response) => {
          console.log(response);
          this.tripsVehicles = response.data.options.filter((x) => x != null);
          this.gettingTripsVehicles = false;
          this.filteredTripsVehicles = response.data.options.filter((item) => item);
          // this.carriersSort = Array.from(new Set(["All", ...this.shippingServices.map((item)=> {return item.orgName})]))
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getShippingServicesByTerminal(dropOff, pickUp) {
      try {
        console.log(dropOff, pickUp);

        const response = await this.$_getShippingServiceByTerminal(dropOff, pickUp);
        this.shippingServiceTerminal = response.data.data.shippingServices;
        console.log(JSON.stringify(this.shippingServiceTerminal, null, 2));
      } catch (error) {
        this.handleError(error);
      }
    },
    async getShippingServiceDetails() {
      try {
        const response = await this.$_getShippingServiceById(
          this.shippingInformation.shippingServiceId
        );
        // this.shippingServices = response.data.data

        this.$store.dispatch("saveShippingService", response.data.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getCostEngine() {
      let shippingService = this.shippingServices.find(
        (x, index) => index == this.selectedShippingIndex
      );

      try {
        let costData = shippingService.costData;
        this.$store.dispatch("saveCostTypes", costData);
        this.costs = costData;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getCostEngineByShipping() {
      const payload = {
        shippingId: this.$store.state.bookingModule.shippingId,
        type: "single",
      };

      try {
        const response = await this.$_getCostEngineByShipping(payload);

        this.$store.dispatch("saveCostTypes", response.data.data);
        this.$store.dispatch("saveCostType", response.data.data.standardCost);

        this.costs = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    setSelected(type) {
      this.costSelected = type;
      this.$store.dispatch("saveCostType", type);
    },
    addStop() {
      this.stopsInputs.push({ name: "" });
    },
    getAddress(addressData) {
      this.shippingInformation.returnOrForwardingAddress = addressData.route;
    },
    getRecAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;
    },
    scrollShippingService(dir) {
      if (dir == "left") {
        this.$refs.shippingservice.scrollLeft -= 100;
      } else if (dir == "right") {
        this.$refs.shippingservice.scrollLeft += 100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping-form__shipping {
  --lightblue: #fbfcfe;
  padding: 2rem 2.5rem;
}

.shipping-form__sender {
  padding: 2rem 2.5rem;
}

.days {
  display: flex;
}

.day {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 5px;
  color: #a5adb7;
  padding: 0.5rem;
  margin-right: 0.5rem;
  font-size: 0.9rem;
  width: 3.25rem;
  text-align: center;
  cursor: pointer;

  &.selected {
    background: #f1cf8c;
    color: var(--primaryblue);
    font-weight: 500;
  }
}

.label {
  color: var(--primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  backdrop-filter: blur(6px);
  border-radius: 2px;
}

.input::placeholder {
  color: #bec4d5;
}

.input:disabled {
  background-color: #f8f8f8;
  cursor: not-allowed;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}

.shipping-services {
  padding: 1.5rem 0rem;
  display: flex;
  gap: 1rem;
  width: 100%;
  overflow-x: scroll;
}

.shipping-service {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  color: var(--primaryblue);
  padding: 1.5rem 0;
  margin-bottom: 1.5rem;
  transition: 0.5s ease-in-out;
  width: 220px;

  &.selected {
    background: var(--primaryblue);
    color: #ffffff;

    hr {
      color: #ffffff;
    }
  }
}

.shipping-service:hover {
  transform: scale(1.05);
}

.service-name {
  opacity: 0.8;
  font-size: 0.9rem;
}

.service-price {
  font-weight: 500;
  font-size: 1.2rem;
  padding: 0.5rem 0 0.75rem;
}

.service-schedule {
  font-size: 0.8rem;
  padding: 1rem 0 0.8rem;
}

.arrival-date {
  font-size: 1rem;
  font-weight: 500;
}

hr {
  width: 80%;
  margin: 0 auto;
}

.row {
  margin-bottom: 1rem;
}

.radio-label span::after {
  background: #bec4d5;
}

.el-date-editor.el-input {
  width: 100%;
}
</style>
